import React, { useCallback } from 'react';
import { decode } from 'he';
import { useSurveyConfig } from 'app/core/survey-config';
import { Button } from 'app/shared/components';
import { modalConfirm } from 'app/shared/utils/modalConfirm';

export interface GotoProps {
  className: string;
}

/**
 * The redirect button.
 */
export default function Goto({ className }: GotoProps) {
  const surveyConfig = useSurveyConfig();
  const {
    data: { gotourl },
    wording
  } = surveyConfig;
  const gotourltxt =
    surveyConfig.translation.gotourltxt || surveyConfig.data.gotourltxt;
  const onClick = useCallback(() => {
    if (surveyConfig.isPreview()) {
      modalConfirm(wording.common.preview.open_redirect, {
        cancelText: 'CANCEL',
        confirmText: 'OK',
        onConfirm: () => window.open(gotourl)
      });
    } else if (gotourl) {
      window.location.href = gotourl;
    }
  }, [surveyConfig, gotourl, wording]);

  if (!gotourl || !gotourltxt) {
    return null;
  }

  return (
    <Button className={className} color="primary" onClick={onClick}>
      {decode(gotourltxt)}
    </Button>
  );
}
